import React from 'react';


function EnforcementRevocationPolicy() {
  return (
    <>

      <div className="max-w-4xl mx-auto py-8">
        <h1 className="text-2xl font-bold text-[#102A43] mb-8 border-b border-gray-200 pb-4">declaration Withdrawal and Status Changes Policy</h1>

        <div className="text-sm text-gray-800 leading-relaxed space-y-8">
          <section>
            <p className="mb-4">
              Maintaining the credibility of the AI Accountability Standards Council registry requires clear procedures for status changes. This policy details the conditions under which declaration may be suspended or withdrawn to protect the integrity of the standards ecosystem.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-[#102A43] mb-3 uppercase tracking-wide">Conditional declaration</h2>
            <p>
              declaration is granted based on the understanding of continued adherence to the standards. Organizations are expected to maintain the workflows and documentation practices verified during the assessment throughout the validity period of the declaration.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-[#102A43] mb-3 uppercase tracking-wide">Grounds for Withdrawal or Status Change</h2>
            <p className="mb-3">The Council may withdraw or suspend declaration for defined reasons, including:</p>
            <ul className="list-disc pl-5 space-y-2">
              <li><strong>Material Misrepresentation:</strong> Providing inaccurate or manipulated information during the application or review process.</li>
              <li><strong>Misuse of Marks:</strong> Using Council logos or declaration marks in a misleading manner or contrary to usage guidelines.</li>
              <li><strong>Failure to Maintain Conformance:</strong> Evidence that the organization no longer maintains the required baseline controls.</li>
              <li><strong>Request by Organization:</strong> The declared entity voluntarily requests to withdraw from the registry.</li>
              <li><strong>Expiration:</strong> The declaration term has ended without renewal.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-[#102A43] mb-3 uppercase tracking-wide">Status Assessment</h2>
            <p>
              Registry status changes are recorded and reflect the Council's assessment based on available information. This is a point-in-time evaluation based on submitted artifacts. By participating in the declaration program, organizations acknowledge the Council’s role in maintaining the accuracy of the registry.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-[#102A43] mb-3 uppercase tracking-wide">declaration Review and Status Change Process</h2>
            <p className="mb-2">The Council follows a structured process for status changes:</p>
            <ol className="list-decimal pl-5 space-y-2">
              <li><strong>Notification:</strong> The organization is notified of a potential issue regarding their declaration status.</li>
              <li><strong>Response:</strong> The organization is given an opportunity to provide clarification or additional documentation.</li>
              <li><strong>Review:</strong> The Council reviews the provided information against the standards requirements.</li>
              <li><strong>Determination:</strong> A decision is made regarding the status of the declaration (e.g., Active, Suspended, Withdrawn).</li>
              <li><strong>Status Update:</strong> The Registry is updated to reflect the current status.</li>
            </ol>
          </section>

          <section>
            <h2 className="text-lg font-bold text-[#102A43] mb-3 uppercase tracking-wide">Registry Status and History</h2>
            <p>
              To ensure transparency for all stakeholders, the Registry maintains a history of declaration status. Withdrawn, suspended, or expired declarations remain visible in the Registry with their respective status clearly marked. This ensures that verification checks provide a complete picture of an organization's declaration history.
            </p>
          </section>

          <div className="pt-8 border-t border-gray-200 mt-8">
            <p className="text-sm font-bold text-[#102A43] mb-2">
              Registry status changes are based on submitted information and documented procedures.
            </p>
            <p className="text-xs text-gray-500">
              Check the status of any declaration at the <a href="/registry" className="text-[#2F80ED] hover:underline">Official Registry</a>.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default EnforcementRevocationPolicy;